var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "SearchPanel",
        {
          attrs: { flex: "", "show-btn": "" },
          on: { getList: _vm.getSearchList },
        },
        [
          _c(
            "div",
            [
              _c("p", [_vm._v("结算单号")]),
              _c("el-input", {
                attrs: {
                  size: "mini",
                  clearable: "",
                  placeholder: "请输入结算单号",
                },
                model: {
                  value: _vm.settlementNo,
                  callback: function ($$v) {
                    _vm.settlementNo = $$v
                  },
                  expression: "settlementNo",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("订单编号")]),
              _c("el-input", {
                attrs: {
                  size: "mini",
                  clearable: "",
                  placeholder: "请输入订单编号",
                },
                model: {
                  value: _vm.orderNo,
                  callback: function ($$v) {
                    _vm.orderNo = $$v
                  },
                  expression: "orderNo",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("提现ID")]),
              _c("el-input", {
                attrs: { size: "mini", placeholder: "请输入提现ID" },
                model: {
                  value: _vm.withdrawId,
                  callback: function ($$v) {
                    _vm.withdrawId = $$v
                  },
                  expression: "withdrawId",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("结算单创建起始时间")]),
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  clearable: "",
                  size: "mini",
                  placeholder: "选择结算单创建起始时间",
                },
                model: {
                  value: _vm.startTime,
                  callback: function ($$v) {
                    _vm.startTime = $$v
                  },
                  expression: "startTime",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("结算单创建结束时间")]),
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  clearable: "",
                  size: "mini",
                  placeholder: "选择结算单创建结束时间",
                },
                model: {
                  value: _vm.endTime,
                  callback: function ($$v) {
                    _vm.endTime = $$v
                  },
                  expression: "endTime",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("结算状态")]),
              _c(
                "el-select",
                {
                  attrs: { size: "mini", clearable: "" },
                  model: {
                    value: _vm.settlementStatus,
                    callback: function ($$v) {
                      _vm.settlementStatus = $$v
                    },
                    expression: "settlementStatus",
                  },
                },
                _vm._l(_vm.settlementStatusArr, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("下单开始时间")]),
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  size: "mini",
                  clearable: false,
                  placeholder: "选择结下单开始时间",
                },
                model: {
                  value: _vm.placeStartTime,
                  callback: function ($$v) {
                    _vm.placeStartTime = $$v
                  },
                  expression: "placeStartTime",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("下单结束时间")]),
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  size: "mini",
                  clearable: false,
                  placeholder: "选择下单结束时间",
                },
                model: {
                  value: _vm.placeEndTime,
                  callback: function ($$v) {
                    _vm.placeEndTime = $$v
                  },
                  expression: "placeEndTime",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("店铺优惠券ID")]),
              _c("el-input", {
                attrs: {
                  size: "mini",
                  clearable: false,
                  placeholder: "请输入优惠券ID",
                },
                model: {
                  value: _vm.couponId,
                  callback: function ($$v) {
                    _vm.couponId = $$v
                  },
                  expression: "couponId",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v(" 收款码订单 ")]),
              _c(
                "el-select",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "请选择",
                    filterable: "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.isOfflineQr,
                    callback: function ($$v) {
                      _vm.isOfflineQr = $$v
                    },
                    expression: "isOfflineQr",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "是", value: 1 } }),
                  _c("el-option", { attrs: { label: "否", value: 0 } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "button-right", size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.download("export")
                },
              },
              slot: "button-right",
            },
            [_vm._v(" 下载订单明细表 ")]
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "button-right", size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.download("goods")
                },
              },
              slot: "button-right",
            },
            [_vm._v(" 下载商品明细表按钮 ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": {
              "font-weight": "bold",
              background: "#F0F2F8",
              color: "#333",
            },
            "element-loading-text": "拼命加载中",
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "projectCodeName", label: "平台" },
          }),
          _c("el-table-column", {
            attrs: { prop: "withdrawId", label: "提现ID" },
          }),
          _c("el-table-column", {
            attrs: { prop: "settlementNo", label: "结算单号" },
          }),
          _c("el-table-column", {
            attrs: { prop: "orderNo", label: "订单编号" },
          }),
          _c("el-table-column", {
            attrs: { prop: "payment", label: "买家实付" },
          }),
          _c("el-table-column", {
            attrs: { prop: "refundFee", label: "退款金额" },
          }),
          _c("el-table-column", {
            attrs: { prop: "couponFee", label: "平台补贴金额" },
          }),
          _c("el-table-column", {
            attrs: { prop: "platCommissionRate", label: "平台佣金比例" },
          }),
          _c("el-table-column", {
            attrs: { prop: "platCommissionFee", label: "平台佣金" },
          }),
          _c("el-table-column", {
            attrs: { prop: "commissionFee", label: "分销佣金" },
          }),
          _c("el-table-column", {
            attrs: { prop: "handlingFee", label: "手续费" },
          }),
          _c("el-table-column", {
            attrs: { prop: "settlementFee", label: "结算金额" },
          }),
          _c("el-table-column", {
            attrs: { prop: "settlementStatusName", label: "结算状态" },
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "结算单创建时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.setTime(scope.row.createTime)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pagination.currentPage,
          "page-sizes": [10, 20, 30, 50],
          "page-size": _vm.pagination.nowPageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.pagination.count,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }